import { render } from "./NavegacaoRegistro.vue?vue&type=template&id=0241bb0e&scoped=true&ts=true"
import script from "./NavegacaoRegistro.vue?vue&type=script&lang=ts"
export * from "./NavegacaoRegistro.vue?vue&type=script&lang=ts"

import "./NavegacaoRegistro.vue?vue&type=style&index=0&id=0241bb0e&scoped=true&lang=css"

import exportComponent from "D:\\Desenvolvimento\\NeoXApp\\NeoX.Frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0241bb0e"]])

export default __exports__